<template>
  <img class="demo-bg" :src="bgImage" alt="" />

  <div class="background-container">
    <v-container style="margin-bottom: 10px; padding: 30px" class="box-container white-box">
      <h1 class="title" :style="{ backgroundColor: color }">
        Endeavour Sports Park: Multipurpose Court Bookings
      </h1>
      <!-- booking information page -->

        <!-- First Name -->
        <FormKit
          label="Name *"
          type="text"
          validation="alpha_spaces_hyphens:latin|required"
          placeholder="John Doe"
          v-model="formData.name"
          validation-label="Name"
        />

        <!-- Email address -->
        <FormKit
          label="Email *"
          type="email"
          validation="required|email"
          placeholder="johnd@mail.com"
          v-model="formData.email"
          validation-label="email"
        />

        <!-- Mobile Number -->
        <FormKit
          label="Mobile Number *"
          type="tel"
          suffix-icon="mobileNumber"
          validation="required|matches:/^[0-9]{10}$/"
          :validation-messages="{
            matches: 'Mobile number must be of 10 digits',
          }"
          placeholder="0412345678"
          v-model="formData.mobileNumber"
          validation-label="Mobile Number"
        />

        <!-- Gender -->
        <FormKit
          label="Gender *"
          type="radio"
          :options="{
            male: 'Male',
            female: 'Female',
            other: 'Other',
          }"
          name="Gender"
          id="gender"
          validation-label="Gender"
          v-model="formData.gender"
        />

        <!-- User Group -->
        <FormKit
          label="UserGroup *"
          type="radio"
          :options="{
            communityUser: 'Community User',
            club: 'Club',
            organisation: 'Organisation',
          }"
          name="UserGroup"
          id="userGroup"
          validation-label="User Group"
          v-model="formData.userGroup"
        />
        <div class="form-section">
        <div class="col-lg-5">
         
                    <v-img @click="openvenueImage" :src='qrImage' alt=""  class="qrimage"> </v-img>
                  </div>
                </div>     
                
        <v-dialog v-model="showzoomedImage" class="openimage" width="3000">
                <v-row>
                  <v-img :src='qrImage' alt=""> </v-img>
                  <v-btn
                   style="height: 26px; width: 27px"
                    icon
                    dark
                    @click="showzoomedImage = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-dialog>
           

        <!-- Court use -->
        <FormKit
          label="Court Use (includes lights & toilet) *"
          type="select"
          :options="courts"
          name="CourtUse"
          id="courtUse"
          validation-label="Court Use"
          placeholder="Please choose a court"
          v-model="formData.courtUse"
        />

        <!-- PlayPickleball -->
        <FormKit
        v-if="formData.courtUse.startsWith('Netball')"
          label="Will you be using the court to play Pickleball? *"
          type="radio"
          :options="{
            yes: 'Yes',
            no: 'No',
          }"
          name="PlayPickleball"
          id="playpickleball"
          validation-label="PlayPickleball"
          v-model="formData.isPickleball"
        />

        <h4 class="tnc">Terms and Conditions</h4>
        <ul class="listoftnc">
          <li>I am over the age of 18</li>
          <li>
            Your pin code will also allow you access to the lights and toilet facilities during your
            booking times. If you are having problems with your code, please call 9725 0222 during
            business hours. After 5:00pm call 9725 0222 and press option 2.
          </li>
          <li>
            No Bikes, Scooters,  Roller skates,  Skateboards permitted on the court.
          </li>
          <li>
            Lights available 6.00am-10.00pm daily
          </li>
          <li>I will be respectful of neighbours and keep noise to a minimum.</li>
          <li>I will leave the facility in a neat and tidy condition.</li>
          <li>I understand smoking and alcohol is not permitted.</li>
          <li>
            I understand that any misuse of Council's facilities could result in action for damages
            against me.
          </li>
        </ul>

        <FormKit
          label="I have read, understood and will abide by the conditions/terms of use. *"
          name="terms"
          type="checkbox"
          validation="accepted"
          validation-label="terms and conditions"
          v-model="formData.acceptTerms"
        />
      <div class="button-container">
        <v-btn :style="{ background: this.color, color: 'white' }" :disabled="isFormIncomplete" variant="text">
          <div @click="submitBooking">Make a booking</div>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { createDirectSingleBookingWithForm } from "../../../../server/config";
import { getBookingGeneral } from "../../../store/vuexStore";
// import EndeavourCourtSignin from "@/assets/EndeavourCourtSignin.jpg"

export default {
  data: () => ({
    overlay: false,
    bgImage: "",
    color: "",
    courts: [
      { label: "Netball Court 1", value: "Netball Court 1" },
      { label: "Netball Court 2", value: "Netball Court 2" },
      { label: "Netball Court 3", value: "Netball Court 3" },
      { label: "Netball Court 4", value: "Netball Court 4" },
      { label: "Netball Court 5", value: "Netball Court 5" },
      { label: "Netball Court 6", value: "Netball Court 6" },
      { label: "Netball Court 7", value: "Netball Court 7" },
      { label: "Netball Court 8", value: "Netball Court 8" },
      { label: "Volleyball Court 1", value: "Volleyball Court 1" },
      { label: "Volleyball Court 2", value: "Volleyball Court 2" },
      { label: "Volleyball Court 3", value: "Volleyball Court 3" },
      { label: "Basketball Court 1", value: "Basketball Court 1" },
      { label: "Basketball Court 2", value: "Basketball Court 2" },
      { label: "Basketball Court 3", value: "Basketball Court 3" },
      { label: "Pickleball Court 1", value: "Pickleball Court 1" },
    ],
    showzoomedImage: false,
    qrImage: "",
    formData: {
        name: '',
        email: '',
        mobileNumber: '',
        gender: '',
        userGroup: '',
        courtUse: '',
        isPickleball: 'no',
        acceptTerms: false
      }
  }),

  methods: {
    redirectTohomepage() {
      this.$router.push({ path: `/bookingapp/endeavourreserve/` });
    },
    setData() {
      this.data = getBookingGeneral(); // Fetching data from vuex store
      this.bgImage = this.data.homepageimage;
      this.color = this.data.color;
    },
    async submitBooking(){
      const createSingleBooking = await createDirectSingleBookingWithForm(this.formData)
      if(createSingleBooking.status === "1"){
        // sessionStorage.setItem("directBookingId", createSingleBooking.FormsResponse.eventid)
        this.$router.push({ path: `/bookingapp/endeavourreserve/directbooking/summary`, query: { bookingId: createSingleBooking.FormsResponse.eventid, result:  createSingleBooking.status} });
      }else{
        this.$router.push({ path: `/bookingapp/endeavourreserve/directbooking/summary`, query: { result:  createSingleBooking.status } });

      }
    },
    openvenueImage() {
      this.showzoomedImage = true;
    },
  },
  async created() {
    this.setData();
    this.overlay = false;
    this.qrImage =   'https://i.imgur.com/ZQIzJmB.png'
  },
  computed: {
    isFormIncomplete() {
      return Object.values(this.formData).some((value) => value === '' || value === false);
    }
  },
};
</script>

<style src="./endeavourDirectBooking.css"></style>
